var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 12,
    viewBox: "0 0 37 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6815 0.28554L16.2561 11.6234H13.3232L15.749 0.28554H18.6815ZM31.0213 7.60641L32.5654 3.34867L33.4539 7.60641H31.0213ZM34.2936 11.6234H37.0065L34.6392 0.28554H32.1351C31.5724 0.28554 31.0977 0.61281 30.8863 1.11735L26.4861 11.6234H29.5661L30.1776 9.93032H33.9405L34.2936 11.6234ZM26.639 7.92148C26.6516 4.92904 22.5008 4.76433 22.5295 3.42762C22.5381 3.02033 22.926 2.58827 23.7732 2.47739C24.1942 2.42248 25.3515 2.3805 26.6656 2.98516L27.1801 0.580872C26.4743 0.324654 25.566 0.078125 24.4364 0.078125C21.5376 0.078125 19.4972 1.61938 19.48 3.8263C19.4617 5.45834 20.9365 6.3691 22.0479 6.91168C23.1905 7.46754 23.5744 7.82352 23.5694 8.32052C23.5619 9.08164 22.6579 9.4168 21.8146 9.43008C20.3398 9.45341 19.4839 9.03212 18.8018 8.71418L18.2703 11.1985C18.9553 11.5132 20.2203 11.7866 21.5326 11.8006C24.6133 11.8006 26.629 10.2784 26.639 7.92148ZM14.4906 0.28554L9.73868 11.6234H6.63787L4.29962 2.57499C4.15752 2.0177 4.03407 1.81388 3.60238 1.57883C2.89796 1.19666 1.7335 0.837449 0.708984 0.614963L0.77896 0.28554H5.76946C6.40534 0.28554 6.9777 0.708981 7.12196 1.44139L8.35712 8.00258L11.4091 0.28554H14.4906Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visa-logo.0ece9b06060ac5f73bae606fa6ae3c62.svg";
export { ForwardRef as ReactComponent };